import API from "../../service/api"

class Group extends API{
  async article_add(params){
    return await this.sendpost(`article/user/article_add/`,params)
  }
  async article_update(params){
    return await this.sendpost(`article/user/article_update/`,params)
  }
  async reply_add(params){
    return await this.sendpost(`article/user/reply_add/`,params)
  }
  async reply_update(params){
    return await this.sendpost(`article/user/reply_update/`,params)
  }
  async reply_delete(postID){
    return await this.sendget("article/user/reply_delete/?id="+postID)
  }
  async article_sticky(params){
    return await this.sendget(`article/user/article_sticky/?postID=${params.postID}&is_sticky=${params.is_sticky}`)
  }
  async article_publish(params){
    return await this.sendget(`article/user/article_publish/?postID=${params.postID}&is_publish=${params.is_publish}`)
  }
  async article_shift_tag(params){
    return await this.sendget(`article/user/article_shift_tag/?postID=${params.postID}&tagID=${params.tagID}`)
  }


  // ===============
  async sendget(url){
    try{
        let rs = await this.get(url);
        return rs;
    }
    catch(e){
        console.log(e)
        return false;
    }
  }

  async sendpost(url,data){
      try{
          let rs = await this.post(url,data);
          return rs;
      }
      catch(e){
          console.log(e)
          return false;
      }
  }

}

export default new Group();